module.exports = __webpack_public_path__ + "static/media/TCRG_Horizontal_Logo_Web.5e8a8797.jpg";